var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"aap"},[_c('p',[_c('small',[_c('center',[_vm._v(_vm._s(_vm.title))])],1)]),_c('vue-gauge',{key:_vm.value,attrs:{"refid":'_' + Math.random().toString(36).substr(2, 9),"options":_vm.myOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }